import { PRIVACY_URL, TERMS_URL, TERMS_VERSION } from '@instanexus/contracts';
import { useTranslation } from './use-translation.js';
/** The pre-login footer links, written once for every console's `AuthPageLayout`. */
export function useTermsLinks() {
    const { t } = useTranslation('common');
    return {
        label: t('terms.footer.label'),
        termsLabel: t('terms.footer.terms'),
        privacyLabel: t('terms.footer.privacy'),
        termsUrl: TERMS_URL,
        privacyUrl: PRIVACY_URL,
    };
}
export function useTermsAgreement() {
    const { t } = useTranslation('common');
    return {
        continueMessage: t('terms.agreement.continue'),
        checkboxMessage: t('terms.agreement.checkbox'),
        requiredMessage: t('terms.agreement.required'),
        termsUrl: TERMS_URL,
        privacyUrl: PRIVACY_URL,
    };
}
/**
 * The `terms` prop for `AppShell`. `acceptedVersion` comes from the session's `me.termsVersion`
 * (`undefined` = the server did not say, or a setup session: never prompt).
 */
export function useTermsGate(acceptedVersion, onAccept) {
    const { t } = useTranslation('common');
    return {
        acceptedVersion,
        currentVersion: TERMS_VERSION,
        onAccept,
        copy: {
            title: t('terms.update.title'),
            message: t('terms.update.message'),
            acceptLabel: t('terms.update.accept'),
            acceptingLabel: t('terms.update.accepting'),
            errorMessage: t('terms.update.error'),
        },
        termsUrl: TERMS_URL,
        privacyUrl: PRIVACY_URL,
    };
}
//# sourceMappingURL=terms.js.map